module.exports = __webpack_public_path__ + "static/media/icon-graph-up.db725555.JPG";